// extracted by mini-css-extract-plugin
module.exports = {"header":"header-2vHcA","logo-container":"logo-container-1fOh1","trigger":"trigger-3N4bh","center":"center-1xBG8","right":"right-3Uss7","action":"action-2Yfq1","logo":"logo-1Z4jx"};